<template lang="pug">
div
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso"
    :tipo="tipoProcesso"
    :numeroProcesso="numeroProcesso"
    :protocolo="protocolo"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :showOs="true",
      :showMunicipios="true",
      :configuracaoFiltro="configuracaoFiltro"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false"
  )
</template>

<script>
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto.vue'
import { mapActions } from 'vuex'
const { filtro } = require('@/utils/' +
  process.env.ESTADO +
  '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {
  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    AppModalVisualizarCompleto,
    Filtro
  },

  mixins: [BaseFiltro],

  data () {
    return {
      filtro: FILTRO_EMPTY('EDITAL_PUBLICACAO'),
      items: [],
      totalElements: 0,
      processosSelecionados: [],
      showModalVisualizarProcesso: false,
      processoTrocado: null,
      tipoProcesso: null,
      configuracaoFiltro: {
        filtroOrdemServico: filtro?.filtroOrdemServico?.EDITAL_PUBLICACAO || [],
        filtroStatusOrdemServico:
          filtro?.filtroStatusOrdemServico?.EDITAL_PUBLICACAO || [],
        filtroSituacao: filtro?.filtroSituacao?.EDITAL_PUBLICACAO || []
      },
      colunas: [
        {
          id: 0,
          titulo: 'Processo',
          propriedade: 'numeroProcesso',
          ordem: 1,
          acoes: [],
          type: 'icone',
          icone: 'comment-alt'
        },
        {
          id: 1,
          titulo: 'CPF/CNPJ do Interessado',
          propriedade: 'cpfCnpjInteressado',
          ordem: 2,
          acoes: []
        },
        {
          id: 2,
          titulo: 'Nome/Razão Social do Interessado',
          propriedade: 'nomeRazaoSocialInteressado',
          ordem: 3,
          acoes: []
        },
        {
          id: 3,
          titulo: 'Data Chegada',
          propriedade: 'dataChegadaSetor',
          ordem: 4,
          acoes: []
        },
        {
          id: 4,
          titulo: 'Tipo de Processo',
          propriedade: 'tipo',
          ordem: 5,
          acoes: []
        },
        {
          id: 5,
          titulo: 'Situação',
          propriedade: 'status',
          ordem: 4,
          acoes: []
        },
        {
          id: 6,
          titulo: 'Ações',
          propriedade: 'tipo',
          ordem: 5,
          acoes: [
            {
              id: 1,
              nome: 'Visualizar Processo',
              icone: 'fa-eye',
              codigo: 'VISUALIZAR_PROCESSO',
              ordem: 1,
              show: this.showVisualizarProcesso
            },
            {
              id: 2,
              nome: 'Cadastrar Edital de Publicação',
              icone: 'fa-file',
              codigo: 'CADASTRAR_PUBLICACAO',
              ordem: 1,
              show: this.showEdital
            },
            {
              id: 3,
              nome: 'Criar publicação',
              icone: 'fa-file',
              codigo: 'CRIAR_PUBLICACAO',
              ordem: 1,
              show: this.showElaborarEdital
            }
          ]
        }
      ],
      numeroProcesso: null,
      protocolo: null
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    this.init()
  },

  watch: {
    async $route (to, from) {
      this.init()
    }
  },

  methods: {
    ...mapActions({
      retornarSetor: 'processo/retornarSetor'
    }),
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    CADASTRAR_PUBLICACAO: async (_this, { item }) => {
      await _this.executarTramitacao(item.id)
      _this.$router.push({
        name: 'analise/analisar',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'ANALISE'
        }
      })
    },
    CRIAR_PUBLICACAO: async (_this, { item }) => {
      _this.$router.push({
        name: 'ELABORAR_EDITAL',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'ELABORAR_EDITAL'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaEditalPublicacaoListagem.vue